import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'

import ProductCarousel, { ProductCardType } from './ProductCarousel'
import useRecentlyViewedProducts from '../../services/useRecentlyViewedProducts'

import styles from '../../styles/LandingPage/ProductCategoryCarousel.module.less'

interface RecentlyViewedProductsCarouselProps {
  productCardType: ProductCardType
  categoryPage?: boolean
}

const RecentlyViewedProductsCarousel: FC<RecentlyViewedProductsCarouselProps> = (props) => {
  const { productCardType, categoryPage = false } = props

  const { t } = useTranslation('products')

  const { data: products, isLoading, carouselType } = useRecentlyViewedProducts()

  return (
    <ProductCarousel
      carouselType={carouselType}
      title={t('products:Recently viewed')}
      productCardType={productCardType}
      products={products}
      isLoading={isLoading}
      hide={!isLoading && !products?.length}
      testId="recently-viewed-products"
      titleSpacerClassName="padding-bottom-spacer-double margin-bottom-zero-important"
      className={`${styles['product-category-mobile-recently-viewed']} ${!categoryPage ? styles['left-margins'] : ''}`}
    />
  )
}

export default RecentlyViewedProductsCarousel
